// extracted by mini-css-extract-plugin
export default {"container":"dashboard_stats_container__lMGIb","compact":"dashboard_stats_compact__3octF","label":"dashboard_stats_label__Bktke","value":"dashboard_stats_value__yRGLm"};